<template>
  <div>
    <div>
      <div class="project-search">
        <div class="flex search-text align-center">
          <div>
            <span>名称：</span>
            <input v-model="pageInfo.name" placeholder="硬盘录像机/行为分析服务器名称" class="searchInput" />
          </div>
          <div class="marginLeft10">
            <span>类型：</span>
            <el-select v-model="pageInfo.type"
                       class="m-2"
                       placeholder="选择类型"
                       size="large">
              <el-option label="硬盘录像机" :value="0" />
              <el-option label="行为分析服务器" :value="1" />
            </el-select>
          </div>
          <div class="marginLeft10">
            <span>账号：</span>
            <input v-model="pageInfo.username" placeholder="请输入账号" class="searchInput" />
          </div>
          <button class="searchBtn" @click="search">搜索</button>
          <button class="resetBtn" @click="reset(null)">重置</button>
        </div>
      </div>
      <div class="project-table" style="margin-top: 20px">
        <div class="flex align-center justify-between paddingBTM20">
          <div class="fontSize20gay">硬盘录像机列表</div>
          <div class="flex">
            <button class="addBtn" @click="showEdit(null)"> + 新增</button>
          </div>
        </div>
        <el-table :data="tableData"
                  border
                  row-key="id"
                  :header-cell-style="{'text-align':'center','color':'#999999','padding':'16px 0','background-color':'#EBEBEB'}"
                  :cell-style="{'text-align':'center'}">
          <el-table-column prop="id" label="设备ID" />
          <el-table-column prop="name" label="名称" />
          <el-table-column prop="ip" label="ip" />
          <el-table-column prop="port" label="端口" />
          <el-table-column prop="username" label="账户名称" />
          <el-table-column prop="time" label="创建时间" />
          <el-table-column fixed="right" label="操作" width="150">
            <template #default="scope">
              <!-- scope.$index 表示 序列号 0、1、2 -->
              <el-button link type="primary" style="color: #3769B9"
                         @click="showEdit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="flex justify-center paddingTD20">
          <!--   分页     -->
          <el-pagination
              :currentPage="pageInfo.page"
              :page-size="pageInfo.limit"
              :page-sizes="[10, 20, 50, 100]"
              :small="true"
              :disabled="false"
              :background="true"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pageInfo.total"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <!-- 操作窗口   -->
    <editDiv v-model="dialogFormVisible" :Row="Info" @closeDiv="closeDiv" @getList="getList" ref="editDiv"></editDiv>
  </div>
</template>

<script>
import editDiv from "@/view/building/buildingEdit.vue"
import {downFile} from "@/api/api";
import {queryEquipmentVideoRecorderPage} from "@/api/monitor";
export default {
  name: 'hardDiskList',
  components:{
    editDiv,
  },
  data(){
    return{
      // -
      getData: queryEquipmentVideoRecorderPage,

      token:localStorage.getItem('token'),
      tableData:[],
      dataInfo:[],
      Info:null,
      dialogFormVisible:false,
      pageInfo:{
        name:'',
        type: '',
        username: '',

        limit:10,
        page:1,
        total:0
      },
      exportIds:'',

    }
  },
  mounted() {
    this.getList();
  },
  methods:{
    reset(){
      this.pageInfo.name = ''
      this.pageInfo.type = ''
      this.pageInfo.username = ''
    },
    search(){
      this.pageInfo.limit=10;
      this.pageInfo.page=1;
      this.getList();
    },
    getList(){
      this.getData(this.pageInfo).then(res=>{
        this.pageInfo.total=parseInt(res.data.total);
        this.tableData=res.data.records;
      })
    },
    showEdit(row){
      if (row) {
        this.$root.useRouter.push({ path:`/monitor/hardDisk/edit/${row.id}` });
        return
      }
      this.$root.useRouter.push({ path:'/monitor/hardDisk/edit/' })
    },
    showRenew(id){
      this.dialogFormVisible1=true;
      this.$refs.renewDiv.getInfo(id);//调用子组件方法
    },
    closeDiv(){
      this.dialogFormVisible=false;
    },
    handleSizeChange(e){//修改每页显示条数
      this.pageInfo.limit=e;
      this.pageInfo.page=1;
      this.getList();
    },
    handleCurrentChange(e){
      this.pageInfo.page=e;
      this.getList();
    },
    showDown(name){
      downFile(name);
    },
    fileVb(res){
      if(res.success){
        this.$root.ElMessage({type:'success',message:res.message});
        this.getList();
      }else{
        this.$root.ElMessage.error(res.message);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.data-title{font-size: 15px;color: #000000}
.data-content{
  font-size: 13px;display: flex;justify-content: space-between;margin-top: 15px;
}
</style>